"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _apolloLink = require("apollo-link");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _default(getNewHeaders, _ref) {
  var operation = _ref.operation,
      forward = _ref.forward;
  return new _apolloLink.Observable(function (observer) {
    var promise = Promise.resolve(getNewHeaders());
    promise.then(function (newHeaders) {
      operation.setContext(function (_ref2) {
        var _ref2$headers = _ref2.headers,
            headers = _ref2$headers === void 0 ? {} : _ref2$headers;
        return {
          headers: _objectSpread(_objectSpread({}, headers), newHeaders)
        };
      });
    }).then(function () {
      var subscriber = {
        next: observer.next.bind(observer),
        error: observer.error.bind(observer),
        complete: observer.complete.bind(observer)
      }; // Retry last failed request

      forward(operation).subscribe(subscriber);
    })["catch"](function (error) {
      // No refresh or client token available, we force user to login
      observer.error(error);
    });
  });
}